// extracted by mini-css-extract-plugin
export default {"button":"UndoButton_button__p6VoW"};